module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('accordion-item', {
    attrs: {
      "show-open": ""
    }
  }, [_c('h2', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n        Total Past & Future Losses\n    ")]), _vm._v(" "), (_vm.chosenRates.length > 1) ? _c('p', {
    staticStyle: {
      "margin-top": "0",
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n        A comparison between discount rates " + _vm._s(_vm.chosenRates[0]) + " and " + _vm._s(_vm.chosenRates[1]) + " in relation to the total of all past and future losses within your book of business.\n    ")]) : _c('p', {
    staticStyle: {
      "margin-top": "0",
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n        A comparison between the total past and future losses for the " + _vm._s(_vm.chosenRates[0]) + " discount rate within your book of business.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex u-flex-center p-discount-rate-comparison__pie-container"
  }, _vm._l((_vm.chosenRates), function(rate) {
    return _c('pie', {
      attrs: {
        "title": "Discount Rate",
        "rate": rate,
        "total": _vm.totalTotal(rate),
        "labels": ['Past Losses', 'Future Losses'],
        "dataset": _vm.dataset(rate)
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "u-text-center"
  }, [_c('chart-legend', {
    attrs: {
      "values": [
        'Past Losses',
        'Future Losses'
      ],
      "legendWidth": _vm.chartLegendWidth,
      "marginTop": "30",
      "marginBottom": "30"
    }
  })], 1), _vm._v(" "), (_vm.chosenRates.length > 1) ? _c('pie-summary', {
    attrs: {
      "rates": _vm.chosenRates,
      "data": [_vm.dataset(_vm.chosenRates[0]), _vm.dataset(_vm.chosenRates[1])]
    }
  }) : _c('pie-summary', {
    attrs: {
      "rates": _vm.chosenRates,
      "data": [_vm.dataset(_vm.chosenRates[0]), _vm.dataset(_vm.chosenRates[0])]
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-491d0de2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/discount-rate-comparison/components/sections/TotalPastFutureLosses.vue
// module id = 1675
// module chunks = 0